/* eslint-disable no-return-assign */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../actions';
import * as c from '../constant';

function ViewSOA({ approve, data, getItem, handleApplyDiscount, getReportAccess }) {
  const setModal = useContext(ModalContext);
  const [iframeKey, setIframeKey] = useState(1);
  const authProfile = getJson('profile') || {};
  const permissions = getJson('permissions');
  const [src, setSrc] = useState('');

  useEffect(() => {
    const args = {
      path: c.BPLS_E2E_URL.replace('{id}', _.get(data, 'id')),
      email: _.get(authProfile, 'email'),
      output: 'I',
    };
    getReportAccess(args, (response) => {
      setSrc(response?.res?.res?.url || '');
    });
  }, []);

  const handleApprove = (e) => {
    e.preventDefault();

    approve(_.get(data, 'id'), {}, () => {
      setModal({ isOpen: false });
      getItem(_.get(data, 'id'));
    });
  };

  useEffect(() => {
    setIframeKey(_.random(1, 1000));
    // getItem(_.get(data, 'id'));
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  key={iframeKey}
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Statement of Account"
                  src={src || ''}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          {['FOR CHECKING'].indexOf(
            _.get(data, 'attributes.transaction_status')
          ) > -1 &&
            ['FOR LICENSE ASSESSMENT'].indexOf(
              _.get(data, 'included.bplsApplication.attributes.status')
            ) > -1 &&
            +_.get(data, 'attributes.is_start_assessment') === 1 &&
            _.get(
              data,
              'included.bplsApplication.attributes.soa_generated_at'
            ) === null &&
            Acl(permissions, ['E2E BPLS APPROVE SOA']) && (
              <>
                <button
                  type="button"
                  onClick={handleApprove}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-dark mr-2   "
                >
                  <span className="font-weight-bold">Approve</span>
                </button>
                <button
                  type="button"
                  onClick={handleApplyDiscount}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mr-2 "
                >
                  <>Apply Discount</>
                </button>
              </>
            )}
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewSOA.propTypes = {
  getItem: PropTypes.instanceOf(Function).isRequired,
  approve: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  handleApplyDiscount: PropTypes.instanceOf(Function).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    item: get(api, `${c.ITEM}.item`) || {},
  };
};

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewSOA);
